import React from 'react';
import {Image, Title, Slideshow} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle19 = () => (<div>

  <Title>Die Gehirn-Computer-Schnittstelle</Title>
  <Slideshow>

    <section>
      <Image
        source={require('./19_Bild_1.jpeg')}
        title='---'
        caption='Gamen nur durch Gedankenkraft: Ein gelähmter Teilnehmer während des Wettkampfs in der Disziplin «Virtuelles Rennen mit Gedankensteuerung».'
      />
    </section>

    <section>
      <Image
        source={require('./19_Bild_2_Unknown-1.jpg')}
        title='---'
        caption='Die Hirnströme der Athleten werden durch Elektroden registriert...'
      />
    </section>

    <section>
      <Image
        source={require('./19_Bild_3_Unknown-2.jpg')}
        title='---'
        caption='... und vom Computer in Signale umgewandelt, die die Spielfigur steuern. Um sie springen oder rennen zu lassen oder um sie abzubremsen, braucht es verschiedene Befehle. Diese erzeugen die Athleten durch bestimmte Denkmuster.'
      />
    </section>

    <section>
      <Image
        source={require('./19_Bild_4_Unknown.jpg')}
        title='---'
        caption='Die Verbindung des Gehirns direkt mit dem Computer nennt sich Brain-Computer-Interface. Um die verschiedenen Muster voneinander zu unterscheiden, braucht es ausgeklügelte Software. Fotos: ETHZ'
      />
    </section>

  </Slideshow>

  <Particle
  number={21}
  />

</div>);

export default Particle19;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle19/Particle19.js
 **/